<template>
    <div class="mb-2">

        <!--        <v-breadcrumbs :items="breadcrumbs">
                    <template v-slot:divider>
                        <v-icon>mdi-chevron-right</v-icon>
                    </template>
                </v-breadcrumbs>-->

        <div v-if="$vuetify.breakpoint.mdAndUp">
            <span v-if="group" class="subtitle-2">
                    <v-icon class="mr-1" :class="{'primary--text': !isDark}" v-text="icons.mdiAccountGroup"></v-icon>
                    {{ group }}
                    <v-icon v-text="icons.mdiSlashForward" class="mr-1" v-if="$vuetify.breakpoint.mdAndUp"></v-icon>
                </span>
            <span v-if="user" class="subtitle-2">
                    <v-icon class="mr-1" :class="{'primary--text': !isDark}" v-text="icons.mdiAccountCircle"></v-icon>
                    {{ user }}
                    <v-icon v-text="icons.mdiSlashForward" class="mr-1" v-if="$vuetify.breakpoint.mdAndUp"></v-icon>
                </span>
            <span v-if="device" class="subtitle-2">
                    <v-icon class="mr-1" :class="{'primary--text': !isDark}" v-text="icons.mdiCellphoneCog"></v-icon>
                    {{ device }}
                <!-- We are hiding the chosenModel name on the mobile phones as chosenModel, is itself a tab name on the mobile. -->
                    <small class="ml-3 grey--text" v-if="$vuetify.breakpoint.mdAndUp">{{ chosenModel }}</small>
                </span>
        </div>
        <div v-else>
            <v-row>
                <v-col>
                    <span v-if="group" class="subtitle-2">
                        <v-icon class="primary--text mr-1" v-text="icons.mdiAccountGroup"></v-icon>
                        {{ group }}
                        <v-icon v-text="icons.mdiSlashForward" class="mr-1" v-if="$vuetify.breakpoint.mdAndUp"></v-icon>
                    </span>
                </v-col>
                <v-col>
                    <span v-if="user" class="subtitle-2">
                    <v-icon class="primary--text mr-1" v-text="icons.mdiAccountCircle"></v-icon>
                    {{ user }}
                    <v-icon v-text="icons.mdiSlashForward" class="mr-1" v-if="$vuetify.breakpoint.mdAndUp"></v-icon>
                </span>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <span v-if="device" class="subtitle-2">
                    <v-icon class="primary--text mr-1" v-text="icons.mdiCellphone"></v-icon>
                    {{ device }}
                        <!-- We are hiding the chosenModel name on the mobile phones as chosenModel, is itself a tab name on the mobile. -->
                    <small class="ml-3 grey--text" v-if="$vuetify.breakpoint.mdAndUp">{{ chosenModel }}</small>
                </span>
                </v-col>
                <v-col>
                    <span v-if="currentSelectedConfiguration" class="subtitle-2">
                    <v-icon class="primary--text mr-1" v-text="icons.mdiCellphoneCog"></v-icon>
                    {{ currentSelectedConfiguration }}
                        <!-- We are hiding the chosenModel name on the mobile phones as chosenModel, is itself a tab name on the mobile. -->
                    <small class="ml-3 grey--text" v-if="$vuetify.breakpoint.mdAndUp">{{ chosenModel }}</small>
                </span>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import {computed, ref, watch} from "vue";
import MixinIcon from "@/mixins/MixinIcon";
import {storeToRefs} from "pinia";
import {usePhonesStore} from "@/stores/PhonesStore";
import {useVuetify} from "@/composables/vuetify";

export default {
    name: 'MobileAppsPath',
    props: {
        group: {
            type: String,
            default: ''
        },
        user: {
            type: String,
            default: ''
        },
        device: {
            type: String,
            default: ''
        },
    },
    setup(props, context) {

        const icons = MixinIcon.data().icons
        let breadcrumbs = ref([])

        if (props.group) {
            breadcrumbs.value.push({
                text: props.group,
                disabled: false
            })
        }
        if (props.user) {
            breadcrumbs.value.push({
                text: props.user,
                disabled: false
            })
        }
        if (props.device) {
            breadcrumbs.value.push({
                text: props.device,
                disabled: false
            })
        }

        const phonesStore = usePhonesStore()
        const {
            chosenModel,
            currentSelectedConfiguration
        } = storeToRefs(phonesStore);

        const vuetify = useVuetify();
        let isDark = computed(() => {
            return vuetify.theme.dark
        })

        return {
            icons,
            chosenModel,
            currentSelectedConfiguration,
            breadcrumbs,
            isDark
        }

    },
}
</script>
